import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {loadingReducer} from './+state/loading.reducer';
import {loadingInitialState} from './+state/loading.init';
import {EffectsModule} from '@ngrx/effects';
import {LoadingEffects} from './+state/loading.effects';
import {CircleLoaderComponent} from './components/circle-loader/circle-loader.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {BarLoaderComponent} from './components/bar-loader/bar-loader.component';

const LOADERS = [CircleLoaderComponent, BarLoaderComponent];

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('loading', loadingReducer, {
            initialState: loadingInitialState
        }),
        EffectsModule.forFeature([LoadingEffects]),

        MatProgressSpinnerModule
    ],
    declarations: [LOADERS],
    exports: [LOADERS]
})
export class LoadingModule {}
